import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type Invite } from 'entities/Users/model/Invite'

export class RowInvite extends RowBase<Invite> {
  constructor(origin: Invite) {
    super(origin)

    makeObservableRowBase(this, {
      id: computed,
      email: computed,
      role: computed,
      roleLabel: computed,
      url: computed,
      createdAt: computed,
      hasSeat: computed,
    })
  }

  get id() {
    return this.origin.id
  }

  get email() {
    return this.origin.email
  }

  get role() {
    return this.origin.role
  }

  get roleLabel() {
    return this.origin.roleLabel
  }

  get hasSeat() {
    return this.origin.hasSeat
  }

  get url() {
    return this.origin.url
  }

  get createdAt() {
    return this.origin.createdAt
  }
}
